import React from 'react';
import './ActivityCard.css';

const ActivityCard = ({ title, description }) => {
  return (
    <div className="activity-card">
      <div className="activity-header">
        <span className="activity-icon">✨</span>
        <span className="activity-label">Activity Idea</span>
      </div>
      <div className="activity-content">
        <div className="activity-title">{title}</div>
        <div className="activity-description">{description}</div>
      </div>
    </div>
  );
};

export default ActivityCard;
